"use client";

import { useMemo } from "react";
import { useChainId } from "wagmi";
import { Chain, mainnet, sepolia } from "wagmi/chains";
import { MEMES_CONTRACT } from "@/constants/constants";

const DROP_FORGE_TESTNET_CONTRACT =
  "0xb84170c1073c7292ed108c3f0d1d2a1f304caa2c";

export enum DropForgeMintingMode {
  MAINNET = "MAINNET",
  TESTNET = "TESTNET",
}

export function useDropForgeMintingConfig(): {
  mode: DropForgeMintingMode;
  chain: Chain;
  contract: string;
} {
  const chainId = useChainId();
  const isTestnet = chainId === sepolia.id;

  return useMemo(() => {
    if (isTestnet) {
      return {
        mode: DropForgeMintingMode.TESTNET,
        chain: sepolia,
        contract: DROP_FORGE_TESTNET_CONTRACT,
      };
    }

    return {
      mode: DropForgeMintingMode.MAINNET,
      chain: mainnet,
      contract: MEMES_CONTRACT,
    };
  }, [isTestnet]);
}
